import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.toggle = this.element.querySelector('[data-bs-toggle="dropdown"]');
    this.watch = this.watchVisibility.bind(this);
    this.stop = this.stopWatching.bind(this);
    this.fit = this.fitMenu.bind(this);
    this.element.addEventListener("show.bs.dropdown", this.fit);
    this.element.addEventListener("shown.bs.dropdown", this.watch);
    this.element.addEventListener("hidden.bs.dropdown", this.stop);
  }

  fitMenu() {
    const menu = this.element.querySelector('.conversation-list-menu');
    if (!menu || !this.toggle) return;
    const rect = this.toggle.getBoundingClientRect();
    // Fit on the roomier side before Popper chooses its placement. Leave
    // room for the viewport edge and Bootstrap's dropdown offset.
    const available = Math.max(rect.top, globalThis.innerHeight - rect.bottom) - 12;
    menu.style.setProperty('--conversation-menu-height', `${Math.max(0, available)}px`);
  }

  watchVisibility() {
    this.stopWatching();
    // Observe only while open. The viewport root respects list clipping too.
    const observer = new IntersectionObserver(([entry]) => {
      if (this.observer !== observer) return;
      if (!entry.isIntersecting || entry.intersectionRatio === 0) {
        globalThis.bootstrap?.Dropdown.getInstance(this.toggle)?.hide();
        this.stopWatching();
      }
    }, { threshold: 0 });
    this.observer = observer;
    observer.observe(this.toggle);
  }

  stopWatching() {
    this.observer?.disconnect();
    this.observer = null;
  }

  disconnect() {
    this.stopWatching();
    this.element.removeEventListener("shown.bs.dropdown", this.watch);
    this.element.removeEventListener("hidden.bs.dropdown", this.stop);
    this.element.removeEventListener("show.bs.dropdown", this.fit);
  }
}
